import { ShieldCheck, BookOpenCheck, Scale } from "lucide-react";

const Row = ({ icon: Icon, h, b }) => (
  <div className="flex items-start gap-3">
    <span className="w-8 h-8 rounded-lg bg-[#0F766E]/10 text-[#0F766E] grid place-items-center shrink-0">
      <Icon className="w-4 h-4" />
    </span>
    <div>
      <div className="text-sm font-semibold text-[#0B1220] font-sora tracking-tight">{h}</div>
      <div className="text-[13px] text-[#475569] leading-relaxed">{b}</div>
    </div>
  </div>
);

const ComplianceStrip = ({ className = "", showStatement = true }) => (
  <div className={`rounded-2xl border border-[#DCE7E3] bg-white p-6 sm:p-7 ${className}`}>
    <div className="grid sm:grid-cols-3 gap-5">
      <Row
        icon={BookOpenCheck}
        h="Educational only"
        b="Plain-English explanations. We do not provide regulated mortgage advice or product recommendations."
      />
      <Row
        icon={Scale}
        h="No credit checks"
        b="Snapshots and calculators use only what you tell us. Nothing here affects your credit file."
      />
      <Row
        icon={ShieldCheck}
        h="Clear commission disclosure"
        b="If you follow our optional link to our broker partner and take out a mortgage through them, MortgagePath may receive a commission from that broker. Conveyancing and survey partner referrals may earn us a referral fee. Always disclosed."
      />
    </div>
    {showStatement && (
      <p className="mt-6 pt-5 border-t border-[#DCE7E3] text-[13px] leading-relaxed text-[#475569]">
        <strong className="text-[#0B1220]">Important.</strong> MortgagePath provides general educational information only.
        It is not mortgage advice, financial advice, a mortgage broker, lender or comparison service. We do not recommend
        specific lenders, products or rates. If you choose to follow our optional link to a regulated mortgage broker,
        you'll deal directly with the broker — MortgagePath doesn't transfer your details.
      </p>
    )}
  </div>
);

export default ComplianceStrip;
